import React, { useRef, useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';

const WebcamPreview = ({ onError }) => {
  const videoRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState('');
  const streamRef = useRef(null);

  // Initialize webcam on component mount
  useEffect(() => {
    startWebcam();
    
    // Clean up on unmount
    return () => {
      stopWebcam();
    };
  }, []);

  const startWebcam = async () => {
    try {
      setError('');
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { 
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: "user"
        } 
      });
      
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        streamRef.current = stream;
        setIsActive(true);
      }
    } catch (err) {
      console.error('Error accessing webcam:', err);
      const errorMessage = `Unable to access webcam: ${err.message}. Please check your camera permissions.`;
      setError(errorMessage);
      if (onError) onError(errorMessage);
    }
  };

  const stopWebcam = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    
    setIsActive(false);
  };

  return (
    <Card className="webcam-card mb-4">
      {error ? (
        <Card.Body className="text-center">
          <div className="alert alert-danger">{error}</div>
          <Button 
            variant="primary" 
            onClick={startWebcam}
            className="mt-2"
          >
            <i className="bi bi-camera-video me-1"></i> Try Again
          </Button>
        </Card.Body>
      ) : (
        <>
          <div className="webcam-container">
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              className="webcam-video"
            />
            
            {isActive && (
              <div className="webcam-controls">
                <Button 
                  variant="outline-light" 
                  size="sm"
                  className="webcam-button"
                  onClick={isActive ? stopWebcam : startWebcam}
                >
                  <i className={`bi ${isActive ? 'bi-camera-video-off' : 'bi-camera-video'}`}></i>
                </Button>
              </div>
            )}
          </div>
          <div className="webcam-footer text-center py-1 small text-muted">
            <i className="bi bi-info-circle me-1"></i>
            Camera preview only - not being recorded
          </div>
        </>
      )}
    </Card>
  );
};

export default WebcamPreview;